import styled from 'styled-components';

import { Analytics16 } from 'ui/icons';
import { fontWeights, spacing } from 'ui/theme';
import { PopoverTrigger } from 'ui/popover';
import {
  Body2NoMargin,
  Body2LightNoMargin,
} from 'modules/frequencyManagement/components/Content.styles';
import { Link } from 'ui/links';
import { pxToRem } from 'utils/convert';

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const Body2Bold = styled(Body2NoMargin)`
  font-weight: ${fontWeights.bold};
`;

export const CenteredAnalyticsIcon = styled(Analytics16)`
  display: flex;
  align-items: center;
`;

export const MetricsKeyValuesContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  gap: ${spacing.half};
`;

export const LightBody2EndAlign = styled(Body2LightNoMargin)`
  text-align: end;
`;

export const FlexLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const PopoverTriggerPaddedWrapper = styled(PopoverTrigger)`
  & div:first-of-type {
    padding: ${spacing.eighth};
  }
`;

export const PopoverErrorWrapper = styled.div`
  max-width: ${pxToRem(248)};
  text-wrap: wrap;
`;
